export default __webpack_public_path__ + "static/media/OUR-GOALS.028905f7.jpg";